export default "__VITE_ASSET__eeg79k4B__"